import { Box, SxProps, Theme } from "@mui/material";
import type { JSX } from "react";

import { ValuationHubCoreModelImage } from "@/api/generatedApi";

interface ImageDragPreviewProps {
  image: ValuationHubCoreModelImage;
  minHeight?: string;
  maxHeight?: string;
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 1,
    bgcolor: "white",
  },
  imageWrapper: (minHeight?: string, maxHeight?: string): SxProps<Theme> => ({
    position: "relative",
    minHeight,
    maxHeight,
    display: "flex",
    overflow: "hidden",
    borderRadius: 1,
  }),
  image: { width: "100%", height: "100%", objectFit: "cover" as const },
};

export const ImageDragPreview = ({ image, minHeight, maxHeight }: ImageDragPreviewProps): JSX.Element => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.imageWrapper(minHeight, maxHeight)}>
        <img src={image?.url ?? undefined} alt={image?.title ?? undefined} style={styles.image} />
      </Box>
    </Box>
  );
};
